// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonIconPrimary_default__iJw6Q","inverse":"ButtonIconPrimary_inverse___0sgW","fullWidth":"ButtonIconPrimary_fullWidth__pNQjh"};